import axiosInstance from './axiosInstance';

export type Notification = {
  id: string;
  message: string;
  recipient: string;
  delivered: boolean;
  assetId: string;
  assetName: string;
  vendorId: string;
  vendorName: string;
  organizationId: string;
  organizationName: string;
  calibrationId: string;
  reminderCount: number;
  createdAt: string;
  modifiedAt: string;
  status: string;
  notifictaionType: string;
  subtype: string;
};

export const notificationRepository = {
  // GET all notifications
  getNotifications: async (): Promise<Notification[]> => {
    const { data } = await axiosInstance.get<Notification[]>('/api/notifications');
    return data;
  },

  // GET a single notification by ID
  getNotificationById: async (id: string): Promise<Notification> => {
    const { data } = await axiosInstance.get<Notification>(`/api/notifications/${id}`);
    return data;
  },

  // Create a new notification
  addNotification: async (
    notificationData: Omit<Notification, 'id' | 'createdAt' | 'modifiedAt'>
  ): Promise<Notification> => {
    const { data } = await axiosInstance.post('/api/notifications', notificationData);
    return data;
  },

  // Update an existing notification
  updateNotification: async (
    id: string,
    notificationData: Partial<Omit<Notification, 'id' | 'createdAt' | 'modifiedAt'>>
  ): Promise<Notification> => {
    const { data } = await axiosInstance.put(`/api/notifications/${id}`, notificationData);
    return data;
  },

  // Delete a notification
  deleteNotification: async (id: string) => {
    return await axiosInstance.delete(`/api/notifications/${id}`);
  },

  //patch 
  patchNotification: async (
    id: string,
    notificationData: Partial<Omit<Notification, 'id' | 'createdAt' | 'modifiedAt'>>
  ): Promise<Notification> => {
    const { data } = await axiosInstance.patch(`/api/notifications/${id}`, notificationData);
    return data;
  },

  // Resend a notification
  resendNotification: async (id: string): Promise<Notification> => {
    const { data } = await axiosInstance.post<Notification>(`/api/notifications/${id}/resend`);
    return data;
  },

  // Search notifications by delivered status
  searchByStatus: async (sent: boolean): Promise<Notification[]> => {
    const { data } = await axiosInstance.get<Notification[]>(
      `/api/notifications/Search(Status)`,
      { params: { sent } }
    );
    return data;
  },

  // Export notifications as CSV
  exportNotifications: async (): Promise<string> => {
    const { data } = await axiosInstance.get<string>(
      "/api/notifications/export?format=csv",
      { responseType: "text" } // returns plain text
    );
    return data;
  },

  // GET paginated notifications
  getPaginatedNotifications: async (
    pageNumber: number,
    pageSize: number,
    assetName: string,
    vendorName: string,
    organizationName: string,
    search: string,
    appliedsearch?: string
  ): Promise<Notification[]> => {
    const { data } = await axiosInstance.get<Notification[]>(
      '/api/notifications',
      { params: { pageNumber, pageSize, assetName, vendorName, organizationName, search, appliedsearch } }
    );
    return data;
  },

};

